import React from "react";
import { useTranslation } from "react-i18next";
import { trackLanguageChange } from "../utils/analytics";
import "../styles/LanguageSwitcher.css";

interface LanguageSwitcherProps {
  variant?: "header" | "footer" | "mobile";
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  variant = "header",
}) => {
  const { i18n, t } = useTranslation();

  const currentLanguage = i18n.language;

  const toggleLanguage = () => {
    const newLang = currentLanguage === "en" ? "fr" : "en";
    i18n.changeLanguage(newLang);
    trackLanguageChange(newLang);
  };

  const otherLanguage = currentLanguage === "en" ? "fr" : "en";
  const otherLanguageLabel = currentLanguage === "en" ? "Français" : "English";

  return (
    <button
      className={`language-switcher language-switcher--${variant}`}
      onClick={toggleLanguage}
      aria-label={`${t("language.switchTo")} ${otherLanguageLabel}`}
      title={`${t("language.switchTo")} ${otherLanguageLabel}`}
    >
      <span className="language-switcher__current">
        {currentLanguage.toUpperCase()}
      </span>
      <span className="language-switcher__divider">/</span>
      <span className="language-switcher__other">
        {otherLanguage.toUpperCase()}
      </span>
    </button>
  );
};

export default LanguageSwitcher;
